export const PAGE_DEFAULT = Object.freeze({
  items: [],
  expand: {}
})

// TODO do we really need this function?
export function getUserData (store) {
  return store.getState().login.userData
}
